import { useEffect, useState } from 'react';
import { useRequest } from '@wappsto/blanket';

const usePoints = () => {
  const { request, send } = useRequest();
  const pointsLoading = request?.status === 'pending';
  const [points, setPoints] = useState<any>(null);

  useEffect(() => {
    let mounted = true;
    const promise = send({
      method: 'GET',
      url: `/point`,
    });
    promise.then((response) => {
      if (response.ok && response.json && mounted) {
        setPoints(response?.json);
      }
    });
    return () => { mounted = false; };
  }, [send]);

  return { points, pointsLoading };
};

export default usePoints;
